import React, { useState, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import { Modal } from '../Modal';
import { MobileSiteNavMenu } from './MobileSiteNavMenu';
import './MobileSiteNavOverlay.scss';

enum Mode {
  Resting,
  Mounted
}

interface Props {
  onClose(): void;
}

export const MobileSiteNavOverlay: React.FC<Props> = ({ onClose }) => {
  const [mode, setMode] = useState(Mode.Resting);

  useEffect(() => setMode(Mode.Mounted), []);

  const handlePreventClose = useCallback(
    (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => event.stopPropagation(),
    []
  );

  return (
    <Modal
      className={classNames('MobileSiteNavOverlay', {
        'MobileSiteNavOverlay--active': mode === Mode.Mounted
      })}
      tabIndex={0}
      role="button"
      onClose={onClose}
    >
      <MobileSiteNavMenu onClick={handlePreventClose} onClose={onClose} />
    </Modal>
  );
};
